/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileHeaderData_tradeFirm = {
    readonly name: string | null;
    readonly " $fragmentRefs": FragmentRefs<"ProfileLocation_tradeFirm" | "ProfileTabs_tradeFirm" | "ProfileContactInfo_tradeFirm" | "ProfileIcon_tradeFirm">;
    readonly " $refType": "ProfileHeaderData_tradeFirm";
};
export type ProfileHeaderData_tradeFirm$data = ProfileHeaderData_tradeFirm;
export type ProfileHeaderData_tradeFirm$key = {
    readonly " $data"?: ProfileHeaderData_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileHeaderData_tradeFirm">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ProfileHeaderData_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ProfileLocation_tradeFirm",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ProfileTabs_tradeFirm",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ProfileContactInfo_tradeFirm",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ProfileIcon_tradeFirm",
      "args": null
    }
  ]
};
(node as any).hash = 'e93e1973f01f0d18ce51149edf9fcdeb';
export default node;
